export type AiModelData = {
  advanced_model: string | null;
  effective_model: string;
  is_advanced_unlocked: boolean;
  unlocked_models: string[];
};

export type ModelOption = {
  value: string | null;
  storedValue: string;
  labelKey: string;
  descriptionKey: string;
  isAdvanced: boolean;
};

export const MODEL_DEFAULT_VALUE = 'default';

export const MODEL_OPTIONS: ModelOption[] = [
  {
    value: null,
    storedValue: MODEL_DEFAULT_VALUE,
    labelKey: 'model.options.default.label',
    descriptionKey: 'model.options.default.description',
    isAdvanced: false,
  },
  {
    value: 'gpt-5.4-2026-03-05',
    storedValue: 'gpt-5.4-2026-03-05',
    labelKey: 'model.options.gpt_5_4.label',
    descriptionKey: 'model.options.gpt_5_4.description',
    isAdvanced: true,
  },
  {
    value: 'gpt-5.5-2026-04-23',
    storedValue: 'gpt-5.5-2026-04-23',
    labelKey: 'model.options.gpt_5_5.label',
    descriptionKey: 'model.options.gpt_5_5.description',
    isAdvanced: true,
  },
  {
    value: 'gpt-5.6-sol',
    storedValue: 'gpt-5.6-sol',
    labelKey: 'model.options.gpt_5_6_sol.label',
    descriptionKey: 'model.options.gpt_5_6_sol.description',
    isAdvanced: true,
  },
  {
    value: 'gpt-5.6-terra',
    storedValue: 'gpt-5.6-terra',
    labelKey: 'model.options.gpt_5_6_terra.label',
    descriptionKey: 'model.options.gpt_5_6_terra.description',
    isAdvanced: true,
  },
  {
    value: 'gpt-5.6-luna',
    storedValue: 'gpt-5.6-luna',
    labelKey: 'model.options.gpt_5_6_luna.label',
    descriptionKey: 'model.options.gpt_5_6_luna.description',
    isAdvanced: true,
  },
  {
    value: 'gpt-6.1-terra',
    storedValue: 'gpt-6.1-terra',
    labelKey: 'model.options.gpt_6_1_terra.label',
    descriptionKey: 'model.options.gpt_6_1_terra.description',
    isAdvanced: true,
  },
];

export const isModelLocked = (opt: ModelOption, unlockedModels: string[]): boolean =>
  opt.isAdvanced && opt.value !== null && !unlockedModels.includes(opt.value);
